import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'main-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {

  constructor() {
    console.log("passou aqui.");
  }

  ngOnInit(): void {
  }

}
